(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player/assets/javascripts/error.js') >= 0) return;  svs.modules.push('/components/racing/stream-player/assets/javascripts/error.js');

'use strict';

const isMobile = svs.core.detect.formfactor.mobile();
const StreamPlayerError = props => React.createElement("div", {
  className: "stream-player-login-background hasError"
}, React.createElement("div", {
  className: "stream-player-login-info"
}, React.createElement("div", {
  className: "icon-holder margin-xs-bottom-1"
}, React.createElement("i", {
  className: "icon icon-800 icon-inverted icon-help"
})), React.createElement("div", {
  className: "text-information f-inverted f-600 margin-xs-bottom-2"
}, "Just nu finns det ingen video tillg\xE4nglig."), props.showReloadButton && React.createElement("div", {
  className: "login-btn"
}, React.createElement("button", {
  className: "btn btn-300 btn-transparent-inverted",
  onClick: () => props.buttonHandler(),
  title: "",
  type: "button"
}, "F\xD6RS\xD6K IGEN")), isMobile && React.createElement("div", {
  className: "fold-back-up-icon align-right"
}, React.createElement("i", {
  className: "icon icon-300 icon-inverted icon-menu-up",
  onClick: () => props.handleClick(false)
}))));
svs.racing.streamplayer.StreamPlayerError = StreamPlayerError;

 })(window);